import React, { Component } from 'react';

import { withOktaAuth } from '@okta/okta-react';

import AppsListV2 from './AppsListV2/AppsListV2';
import CustomLogoIcon from './CustomLogoIcon/CustomLogoItem';
import {
  StyledNavbarContainer,
  StyledLeftSection,
  StyledRightSection,
  StyledLogo,
  StyledDivider,
} from './HeaderV2.styles';
import UserInfoV2 from './UserInfoV2/UserInfoV2';

import { getEnvSuffix } from '../../helpers/getEnv';
import { isBrokerOrFlexpert } from '../../helpers/roles/isBrokerOrFlexpert';
import { lightTheme } from '../../themes/light';
import { API_URLS } from '../common/headers';

class NavBarV2 extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.forwardTo = this.forwardTo.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.openAppsList = this.openAppsList.bind(this);

    this.state = {
      isModalOpen: false,
      isMenuOpen: false,
      anchorEl: null,
      anchorAppsList: null,
    };
    this.arrowRef = React.createRef();
  }

  async logout() {
    localStorage.clear();
    sessionStorage.clear();
    await this.props.oktaAuth.signOut({ revokeAccessToken: false });
  }

  forwardTo() {
    window.open(`https://portfoliocanvas${getEnvSuffix()}.cbre.com/administrationv2`, '_blank');
  }

  downloadFile() {
    const element = document.createElement('a');

    element.setAttribute('href', API_URLS.userGuideURL);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  showVideo = (event) => {
    event.preventDefault();
    this.setState({ isModalOpen: true });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null, anchorAppsList: null });
  };

  openMenu = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: event.currentTarget });
  };

  openAppsList = (event) => {
    event.preventDefault();
    this.setState({ anchorAppsList: event.currentTarget });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const res = JSON.parse(sessionStorage.getItem('result'));
    let flexpertImg, userData;

    const firstName = this.props.authState.idToken.claims.firstname || '';
    const lastName = this.props.authState.idToken.claims.lastname || '';

    const userName = `${firstName} ${lastName}`.trim();
    const userEmail = this.props.authState.idToken.claims.email;

    // const isFlexpert = userData?.Flexpert?.length ? 'Flexpert' : '';

    if (res) {
      userData = res?.data?.records?.[0]?.fields;

      if (userData) {
        flexpertImg = userData.FlexpertPhoto?.[0]?.thumbnails?.small?.url;
      }
    }

    return (
      <StyledNavbarContainer container>
        <StyledLeftSection item xs={6}>
          <StyledLogo>
            <CustomLogoIcon
              style={{ fontSize: '20px', width: '120px', color: lightTheme.palette.secondary.main }}
            />
          </StyledLogo>
        </StyledLeftSection>

        <StyledRightSection item xs={6}>
          <UserInfoV2
            userName={userName}
            userData={userData}
            userEmail={userEmail}
            flexpertImg={flexpertImg}
            anchorEl={this.state.anchorEl}
            openMenu={this.openMenu}
            closeMenu={this.closeMenu}
            forwardTo={this.forwardTo}
            logout={this.logout}
          />

          {/* {isBroker() && <StyledDivider orientation="vertical" />}

          {isBroker() && (
            <AppsListV2
              openAppsList={this.openAppsList}
              anchorAppsList={this.state.anchorAppsList}
              arrowRef={this.arrowRef}
              closeMenu={this.closeMenu}
              forwardTo={this.forwardTo}
            />
          )} */}
        </StyledRightSection>
      </StyledNavbarContainer>
    );
  }
}

export default withOktaAuth(NavBarV2);
